import {ExpenseUnit} from "@/models/Enums";
import RentaToolsConstants from "@/helpers/RentaToolsConstants";

export default class BaseAdditionalExpenseRecord {
    public id: string | null = null;

    public typeId: string = RentaToolsConstants.defaultGuid;

    public name: string = "";

    public externalId: string = "";

    public value: number = 0;

    public invoiced: boolean | null = null;

    public isCustom: boolean = false;

    public unit: ExpenseUnit = ExpenseUnit.Piece;

    public price: number | null = null;

    public isBaseAdditionalExpenseRecord: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof BaseAdditionalExpenseRecord) || ((from as any).isBaseAdditionalExpenseRecord === true));
    }

    public static isValid(expenseValue: BaseAdditionalExpenseRecord): boolean {
        return (!!expenseValue.typeId &&
            expenseValue.typeId != RentaToolsConstants.defaultGuid &&
            expenseValue.name.trim().length > 0 &&
            expenseValue.externalId.trim().length > 0 &&
            expenseValue.value > 0 &&
            expenseValue.unit != null);
    }
}